import 'core-js/fn/promise'
import 'core-js/fn/object/assign'
import React from 'react'
import { hydrate } from 'react-dom'
import { createStore, applyMiddleware } from 'redux'
import { BrowserRouter } from 'react-router-dom'
import { createLogger } from 'redux-logger'
import Routes from './Routes.jsx'
import combinedReducers from './reducers/index'
import { getBaseName } from './utils/baseName'

const logger = createLogger()
const initialState = window.__INITIAL_STATE__ || {}
const store = createStore(combinedReducers, initialState, applyMiddleware(logger))
delete window.__INITIAL_STATE__

hydrate(
    <BrowserRouter basename={getBaseName(initialState.activeLang)}>
        <Routes store={store} />
    </BrowserRouter>
    , document.getElementById('RootComponent')
)




// WEBPACK FOOTER //
// ./src/scripts/index.js